import { cloneElement } from 'react';

import { useFormFieldArray } from './context';

import type { FC, ReactElement } from 'react';

export interface FieldControlProps {
  children: ReactElement<{ index: number; id: string; field?: Record<PropertyKey, unknown> }>;
}

export const FieldArray: FC<FieldControlProps> = ({
  children: child,
}) => {
  const { fields } = useFormFieldArray();

  return fields.map((field, index) => (
    cloneElement( child, {
      key: field.id,
      id: field.id,
      field,
      index,
    } )
  ));
};
